export default __webpack_public_path__ + "334cd1eda151e6d413bffb87b4c526e1.png";